export const BLOG_INDEX_PAGE_LIMIT = 6;
